import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI = '[BenutzerverwaltungModul] PostFunktionsbereichAdminHinzufuegenMulti laden';
export const POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_AUSFUEHREN = '[BenutzerverwaltungModul] PostFunktionsbereichAdminHinzufuegenMulti ausführen';
export const POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_ERFOLGREICH = '[BenutzerverwaltungModul] PostFunktionsbereichAdminHinzufuegenMulti laden erfolgreich';
export const POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_FEHLER = '[BenutzerverwaltungModul] PostFunktionsbereichAdminHinzufuegenMulti Ladefehler';
export const POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostFunktionsbereichAdminHinzufuegenMulti nicht ausgeführt (evtl. Offline)';


export class PostFunktionsbereichAdminHinzufuegenMultiAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI;
        constructor(public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminHinzufuegenMultiAusfuehrenAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_AUSFUEHREN;
        constructor(public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminHinzufuegenMultiErfolgreichAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.FunktionsbereichIdentifier, public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminHinzufuegenMultiFehlerAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_FEHLER;
        constructor(public payload: any, public funktionsbereichBenutzerMultiRequest: api.FunktionsbereichBenutzerMultiRequest, public optPayload: any = null) {}
    }
export class PostFunktionsbereichAdminHinzufuegenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandFunktionsbereichAdminHinzufuegenMultiActions =
    PostFunktionsbereichAdminHinzufuegenMultiAction
    | PostFunktionsbereichAdminHinzufuegenMultiAusfuehrenAction
    | PostFunktionsbereichAdminHinzufuegenMultiErfolgreichAction
    | PostFunktionsbereichAdminHinzufuegenMultiFehlerAction
    | PostFunktionsbereichAdminHinzufuegenMultiNichtAusgefuehrtAction
    ;
